import ReactDOM from 'react-dom/client';
import App from './App';
import { ClearPersistedStorage } from "./components/MembershipImpersonation/MembershipImpersonationContext";
import { oneTabCheck } from './one-tab-to-rule-them-all';
import { ErrorBoundaryWithAppInsights } from './components/ErrorBoundaryWithAppInsights';

ClearPersistedStorage();
oneTabCheck();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundaryWithAppInsights><App /></ErrorBoundaryWithAppInsights>);
